import React from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';

const SearchInput = ({ searchTerm, onSearchChange, onClearSearch, resultsCount }) => {
  const { language } = useLanguage();

  const placeholderText = language === 'en' 
    ? 'Search articles by title or author...' 
    : 'Cerca articoli per titolo o autore...';

  const clearText = language === 'en' ? 'Clear search' : 'Cancella ricerca';
  
  const resultsText = language === 'en' 
    ? `${resultsCount} ${resultsCount === 1 ? 'result' : 'results'} found`
    : `${resultsCount} ${resultsCount === 1 ? 'risultato trovato' : 'risultati trovati'}`;

  return (
    <div className="bg-white rounded-lg shadow-md p-4 mb-6">
      <div className="flex items-center mb-3">
        <FaSearch className="text-gray-600 mr-2" />
        <h3 className="text-lg font-semibold text-gray-900">
          {language === 'en' ? 'Search Articles' : 'Cerca Articoli'}
        </h3>
      </div>
      
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <FaSearch className="h-4 w-4 text-gray-400" />
        </div>
        
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={placeholderText}
          className="block w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
        />
        
        {searchTerm && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
            <button
              onClick={onClearSearch}
              className="h-4 w-4 text-gray-400 hover:text-gray-600 transition-colors"
              title={clearText}
            >
              <FaTimes />
            </button>
          </div>
        )}
      </div>
      
      {searchTerm && (
        <div className="mt-3 text-sm text-gray-600 flex items-center">
          <span className="mr-2">🔍</span>
          <span>{resultsText}</span>
          {searchTerm && (
            <span className="ml-2 px-2 py-1 bg-indigo-100 text-indigo-800 rounded-full text-xs font-medium">
              "{searchTerm}"
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchInput;